import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { LottieModule } from 'ngx-lottie';

import { CloudinaryUrlModule } from '../cloudinary-url/cloudinary-url.module';
import { PipeModule } from '../pipe/pipe.module';
import { AnimateProfileComponent } from './animate-profile/animate-profile.component';
import { BlogCardComponent } from './blog-card/blog-card.component';
import { ButtonComponent } from './button/button.component';
import { ChipsContainerComponent } from './chips/chip-container/chip-container.component';
import { ChipsComponent } from './chips/chips.component';
import { JobAdvantagesComponent } from './job-advantages/job-advantages.component';
import { JumbotronComponent } from './jumbotron/jumbotron.component';
import { OfferCardComponent } from './offer-card/offer-card.component';
import { OfferGroupCardComponent } from './offer-group-card/offer-group-card.component';
import { ReppleComponent } from './repple/repple.component';
import { SplashMaskComponent } from './splash-mask/splash-mask.component';
import { StatusGaugeComponent } from './status-gauge/status-gauge.component';
import { TeamCardComponent } from './team-card/team-card.component';
import { VideoBlockComponent } from './video-block/video-block.component';

@NgModule({
  declarations: [
    ButtonComponent,
    BlogCardComponent,
    TeamCardComponent,
    StatusGaugeComponent,
    JumbotronComponent,
    OfferCardComponent,
    ChipsComponent,
    ReppleComponent,
    ChipsContainerComponent,
    OfferGroupCardComponent,
    AnimateProfileComponent,
    SplashMaskComponent,
    VideoBlockComponent,
    JobAdvantagesComponent,
  ],
  exports: [
    ButtonComponent,
    BlogCardComponent,
    TeamCardComponent,
    StatusGaugeComponent,
    JumbotronComponent,
    OfferCardComponent,
    ChipsComponent,
    ChipsContainerComponent,
    OfferGroupCardComponent,
    AnimateProfileComponent,
    SplashMaskComponent,
    VideoBlockComponent,
    JobAdvantagesComponent,
  ],
  imports: [CommonModule, RouterModule, LocalizeRouterModule, TranslateModule, CloudinaryUrlModule, LottieModule, PipeModule],
})
export class UiModule {}
